import VendorsSliderPresenter from "../components/vendors-slider/presenter/vendors.js";

const vendorsListWrapper = document.querySelector(`.vendors-list-wrapper`);
const vendorsSliderComponent = new VendorsSliderPresenter(vendorsListWrapper);
vendorsSliderComponent.init();
